import { TemperaturesList } from "./TemperaturesList";
export default TemperaturesList;
